// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_titleWrapper__kSmEr {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 16px;
  flex: 1 1;
}
.styles_titleWrapper__kSmEr h1 {
  font-size: 2rem;
  font-weight: 700;
  color: #6ba7a8;
}
.styles_titleWrapper__kSmEr .styles_edit__Uziyx {
  width: 24px;
}
.styles_titleWrapper__kSmEr .styles_edit__Uziyx:hover {
  cursor: pointer;
}
.styles_titleWrapper__kSmEr input {
  border-radius: 0.5em;
  border: 1px solid #7c7676;
  width: 100%;
  padding: 4px 2px;
  font-size: 2rem;
  font-weight: 700;
  color: #6ba7a8;
  width: max-content;
}
.styles_titleWrapper__kSmEr input:focus {
  border-color: #6ba7a8;
  outline: none;
}`, "",{"version":3,"sources":["webpack://./src/components/reusable/SingleTranscript/TranscriptTitle/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,SAAA;EACA,SAAA;AACF;AAAE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAEJ;AAAE;EACE,WAAA;AAEJ;AADI;EACE,eAAA;AAGN;AACE;EACE,oBAAA;EACA,yBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AACJ;AACI;EACE,qBAAA;EACA,aAAA;AACN","sourcesContent":[".titleWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 16px;\n  flex: 1;\n  h1 {\n    font-size: 2rem;\n    font-weight: 700;\n    color: #6ba7a8;\n  }\n  .edit {\n    width: 24px;\n    &:hover {\n      cursor: pointer;\n    }\n  }\n\n  input {\n    border-radius: 0.5em;\n    border: 1px solid #7c7676;\n    width: 100%;\n    padding: 4px 2px;\n    font-size: 2rem;\n    font-weight: 700;\n    color: #6ba7a8;\n    width: max-content;\n\n    &:focus {\n      border-color: #6ba7a8;\n      outline: none;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"titleWrapper": `styles_titleWrapper__kSmEr`,
	"edit": `styles_edit__Uziyx`
};
export default ___CSS_LOADER_EXPORT___;
